import { Reveal } from "@/components/Reveal";

const featured = {
  key: "live-map",
  src: "/assets/shot-livemap.webp",
  alt: "JomKonvoi live map showing the convoy route, navigation, speed and distance",
  title: "Live Map",
  body: "See your convoy and stay on route.",
};

const secondary = [
  {
    key: "sos-chat",
    src: "/assets/shot-sos.webp",
    alt: "JomKonvoi Priority SOS alert screen with navigate to sender and open chat actions",
    title: "SOS Chat",
    body: "Alert your convoy quickly when you need attention.",
  },
  {
    key: "convoy-hub",
    src: "/assets/shot-map.jpeg",
    alt: "JomKonvoi convoy hub where organisers manage members, invites, QR codes and the route",
    title: "Convoy Hub",
    body: "Where organisers run the group — members, invites, and the route, all in one place.",
  },
];

const Frame = ({ item, wide = false, rotate = "", testId }) => (
  <div className={`relative ${rotate}`} data-testid={testId}>
    <div className="pointer-events-none absolute -inset-8 rounded-full bg-[#FF3333]/10 blur-[60px]" aria-hidden="true" />
    <div
      className={`relative overflow-hidden rounded-[2rem] border border-white/15 shadow-[0_30px_80px_rgba(0,0,0,0.7)] ${
        wide ? "w-[270px] sm:w-[320px]" : "w-[230px] sm:w-[250px]"
      }`}
    >
      <img src={item.src} alt={item.alt} loading="lazy" className="block w-full" />
    </div>
  </div>
);

export const Screenshots = () => (
  <section id="the-app" className="spotlight relative overflow-hidden py-24 sm:py-32" data-testid="app-screenshots-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="label-tech text-[#00F0FF]">Inside the app</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-black tracking-tighter text-white sm:text-5xl lg:text-6xl">
          Built for the moving crew.
        </h2>
      </Reveal>

      <div className="mt-16 grid items-start gap-14 sm:mt-20 md:grid-cols-12 md:gap-8">
        <Reveal className="md:col-span-6">
          <div className="flex flex-col items-center text-center md:items-start md:text-left">
            <Frame item={featured} wide testId="app-screenshot-live-map" />
            <p className="label-tech mt-8 text-[#FF3333]">{featured.title}</p>
            <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
              {featured.body}
            </h3>
          </div>
        </Reveal>
        <div className="grid gap-14 sm:grid-cols-2 md:col-span-6 md:grid-cols-1 lg:grid-cols-2">
          {secondary.map((it, i) => (
            <Reveal key={it.key} delay={0.1 + i * 0.1} className={i === 1 ? "lg:translate-y-10" : ""}>
              <div className="flex flex-col items-center text-center">
                <Frame item={it} rotate={i === 1 ? "sm:rotate-2" : "sm:-rotate-2"} testId={`app-screenshot-${it.key}`} />
                <p className="label-tech mt-8 text-neutral-500">{it.title}</p>
                <h3 className="mt-2 max-w-[260px] font-display text-xl font-bold tracking-tight text-white">
                  {it.body}
                </h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
